import './Services.css'

const Services = () => {
    return (
        <div>
            <div className="gdservices" data-aos="fade-up"
                data-aos-duration="2000">
                <div className="gdservices-heading">
                    <h3>AMENITIES AND SERVICES</h3>
                </div>
                <div className="gdservices-cards">
                    <div className="gdservices-card">
                        <img src="./DowntownPhotos/Services/1.png" alt="services" />
                        <hr />
                        <p>Swiss Cafe</p>
                    </div>
                    <div className="gdservices-card">
                        <img src="./DowntownPhotos/Services/2.png" alt="services" />
                        <hr />
                        <p>BUY-ME</p>
                    </div>
                    <div className="gdservices-card">
                        <img src="./DowntownPhotos/Services/3.png" alt="services" />
                        <hr />
                        <p>Eventives</p>
                    </div>
                    <div className="gdservices-card">
                        <img src="./DowntownPhotos/Services/4.png" alt="services" />
                        <hr />
                        <p>Inspirations Gym</p>
                    </div>
                    <div className="gdservices-card">
                        <img src="./DowntownPhotos/Services/5.png" alt="services" />
                        <hr />
                        <p>Inspirations Pool</p>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Services